import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  Dropdown,
  InputNumber,
  Tag,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  SettingOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

// TODOS
const options_todos = [
  { value: 0, label: "Personalizado" },
  { value: 1, label: "Todos" },
];

export const AvaliacoesParametrosCadAvaliadores = () => {
  const navigate = useNavigate();
  const { id_grupo } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);
  const [search, setSearch] = useState("");

  // DADOS
  const [grupo, setGrupo] = useState({});
  const [tipos, setTipos] = useState([]);

  useEffect(() => {
    if (id_grupo) {
      carregarGrupo(id_grupo);
      listarGruposAvaliadores(id_grupo);
    }
    carregarTipos();
  }, [id_grupo]);

  // CARREGAR GRUPO
  const carregarGrupo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_parametros_grupos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setGrupo(api.response.data);
    } else {
      navigate("/avaliacoes/parametros/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR GRUPO
  const carregarTipos = async () => {
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_parametros_tipos/listar_ativos`, []);
    if (api.statusCode === 200) {
      let array_tipos = [];
      if (api.response.data) {
        api.response.data?.forEach((e) => {
          array_tipos.push({ label: e?.descricao, value: e?.id });
        });
      }
      setTipos(array_tipos);
    } else {
      navigate("/avaliacoes/parametros/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarGruposAvaliadores = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_parametros_avaliadores/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarGruposAvaliador = async (formulario) => {
    if (!formulario.id_avaliacoes_parametros_cad_grupos) return;
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_parametros_avaliadores/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarGruposAvaliadores(id_grupo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarGruposAvaliador = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_parametros_avaliadores/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarGruposAvaliadores(id_grupo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarGruposAvaliador = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_parametros_avaliadores/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        id_avaliacoes_parametros_cad_tipos: api.response.data?.id_avaliacoes_parametros_cad_tipos,
        todos_filiais: api.response.data?.todos_filiais,
        todos_setores: api.response.data?.todos_setores,
        todos_cargos: api.response.data?.todos_cargos,
        status: api.response.data?.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarGruposAvaliador = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_parametros_avaliadores/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarGruposAvaliadores(id_grupo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Tipo",
      dataIndex: "tipo",
      sorter: (a, b) => a.tipo?.localeCompare(b.tipo),
    },
    {
      key: "filiais",
      title: "Filiais",
      render: (_, e) => (e.todos_filiais === 1 ? "Todas" : "Personalizado"),
      sorter: (a, b) =>
        (a.todos_filiais === 1 ? "Todas" : "Personalizado")?.localeCompare(
          b.todos_filiais === 1 ? "Todas" : "Personalizado"
        ),
    },
    {
      key: "setores",
      title: "Setores",
      render: (_, e) => (e.todos_setores === 1 ? "Todos" : "Personalizado"),
      sorter: (a, b) =>
        (a.todos_setores === 1 ? "Todos" : "Personalizado")?.localeCompare(
          b.todos_setores === 1 ? "Todos" : "Personalizado"
        ),
    },
    {
      key: "cargos",
      title: "Cargos",
      render: (_, e) => (e.todos_cargos === 1 ? "Todos" : "Personalizado"),
      sorter: (a, b) =>
        (a.todos_cargos === 1 ? "Todos" : "Personalizado")?.localeCompare(
          b.todos_cargos === 1 ? "Todos" : "Personalizado"
        ),
    },
    {
      key: "afetados",
      title: "Afetados",
      render: (_, e) => (e.afetados > 0 ? <Tag color="green">{e.afetados}</Tag> : <Tag color="red">{e.afetados}</Tag>),
      sorter: (a, b) => a.afetados?.toString()?.localeCompare(b.todos_cargos?.toString()),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 150,
      render: (_, e) => {
        const items = [
          e.todos_filiais === 0 && {
            key: "1",
            label: "Liberações Filiais",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/avaliacoes/parametros/avaliadores/${id_grupo}/filiais/${e.id}`),
          },
          e.todos_setores === 0 && {
            key: "2",
            label: "Liberações Setores",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/avaliacoes/parametros/avaliadores/${id_grupo}/setores/${e.id}`),
          },
          e.todos_cargos === 0 && {
            key: "3",
            label: "Liberações Cargos",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/avaliacoes/parametros/avaliadores/${id_grupo}/cargos/${e.id}`),
          },
          {
            key: "4",
            label: "Liberações Colaboradores",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/avaliacoes/parametros/avaliadores/${id_grupo}/colaboradores/${e.id}`),
          },
        ].filter((i) => i !== false);

        return (
          <Space.Compact>
            {items.length > 0 && (
              <Dropdown menu={{ items }}>
                <Button loading={loading} icon={<SettingOutlined />} />
              </Dropdown>
            )}

            <Tooltip title="Editar">
              <Button loading={loading} onClick={() => carregarGruposAvaliador(e.id)} icon={<EditOutlined />} />
            </Tooltip>
            <Tooltip title="Excluir">
              <Button
                loading={loading}
                icon={<DeleteOutlined />}
                onClick={() => {
                  modal.confirm({
                    title: "Deseja deletar este registro?",
                    okText: "Sim",
                    cancelText: "Cancelar",
                    onOk() {
                      deletarGruposAvaliador(e.id);
                    },
                  });
                }}
              />
            </Tooltip>
          </Space.Compact>
        );
      },
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_avaliacoes_parametros_cad_grupos = id_grupo;
    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarGruposAvaliador(formulario);
    } else {
      cadastrarGruposAvaliador(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter((val) => val.tipo?.toLowerCase().includes(pesquisar.toLowerCase()));

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Grupo Avaliador
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="id_avaliacoes_parametros_cad_tipos"
                label="Tipo"
                rules={[{ required: true, message: "Selecione o tipo!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o tipo"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={tipos}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="todos_filiais"
                label="Filiais"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_todos}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="todos_setores"
                label="Setores"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_todos}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="todos_cargos"
                label="Cargos"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_todos}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Avaliações" onClickBack={() => navigate("/avaliacoes/parametros/grupos")} />
            <HeaderTitle
              title="Parâmetros Gestão Avaliadores"
              subtitle={
                <Text italic>
                  <TeamOutlined /> {grupo?.descricao ?? ""}
                </Text>
              }
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Table
                loading={loading}
                rowKey="id"
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
